import { useTranslation } from 'react-i18next';

import { ChevronDownIcon, ChevronUpIcon } from '@shared/assets/icons';
import { i18TranslationNS, Translation } from '@shared/config/i18n';

import s from './HeaderNavigation.module.css';
import { HeaderNavigationDropdown } from './HeaderNavigationDropdown';
import { HeaderNavigationFlyout } from './HeaderNavigationFlyout';
import { useHeaderNavigationData } from '../../model/useHeaderNavigationData';
import { useHeaderNavigationFloating } from '../../model/useHeaderNavigationFloating';

export const HeaderNavigation = () => {
	const { t } = useTranslation(i18TranslationNS);

	const labels = {
		switchTo: t(Translation.HEADER_NAV_SWITCH_TO),
		openMenu: t(Translation.HEADER_NAV_OPEN_MENU),
		closeMenu: t(Translation.HEADER_NAV_CLOSE_MENU),
		allCompanies: t(Translation.HEADER_NAV_ALL_COMPANIES),
	};

	const {
		refs,
		floatingStyles,
		flyout,
		isOpen,
		isFlyoutOpen,
		toggleMenu,
		handleFlyoutToggle,
		closeAll,
	} = useHeaderNavigationFloating();

	const {
		title,
		subtitle,
		activeItem,
		switchItems,
		showAllCompaniesButton,
		primaryCompanyItem,
		companyCount,
		sortedCompanies,
		isCompanyMode,
		activeCompanyId,
		handleCompanySelect,
	} = useHeaderNavigationData({ closeAll });

	return (
		<div className={s.headerNavigation} ref={refs.setReference}>
			<button
				type='button'
				className='dropdown-navigation__trigger'
				onClick={toggleMenu}
				aria-expanded={isOpen}
				aria-haspopup='menu'
				aria-label={isOpen ? labels.closeMenu : labels.openMenu}
			>
				<span className='dropdown-navigation__top-row'>
					<span className='body-medium-base dropdown-navigation__title'>{title}</span>
					{isOpen ? (
						<ChevronUpIcon
							className='dropdown-navigation__chevron'
							aria-hidden='true'
							focusable='false'
						/>
					) : (
						<ChevronDownIcon
							className='dropdown-navigation__chevron'
							aria-hidden='true'
							focusable='false'
						/>
					)}
				</span>
				<span className='body-medium-xs dropdown-navigation__subtitle'>{subtitle}</span>
			</button>

			{isOpen && (
				<HeaderNavigationDropdown
					activeItem={activeItem}
					switchItems={switchItems}
					showAllCompaniesButton={showAllCompaniesButton}
					primaryCompanyItem={primaryCompanyItem}
					companyCount={companyCount}
					flyoutTriggerRef={flyout.refs.setReference}
					onFlyoutToggle={handleFlyoutToggle}
					switchToLabel={labels.switchTo}
					allCompaniesLabel={labels.allCompanies}
					floatingRef={refs.setFloating}
					floatingStyles={floatingStyles}
				/>
			)}

			{isOpen && isFlyoutOpen && (
				<HeaderNavigationFlyout
					companies={sortedCompanies}
					isCompanyMode={isCompanyMode}
					activeCompanyId={activeCompanyId}
					onCompanySelect={handleCompanySelect}
					floatingRef={flyout.refs.setFloating}
					floatingStyles={flyout.floatingStyles}
				/>
			)}
		</div>
	);
};
